import { ConversationAuditLogEntry } from 'apis/auditLogs';

import { LogEntry } from './logEntry';
import { UserLink } from './userLink/userLink';

type ConversationAssignedProps = {
  entry: ConversationAuditLogEntry<'CONVERSATION_ASSIGNED'>;
};

export const ConversationAssigned = ({
  entry,
}: ConversationAssignedProps): JSX.Element => {
  const agentLink = (
    <UserLink userId={entry.agent_id}>
      {entry.agent_name ?? entry.agent_id}
    </UserLink>
  );

  const text = <>Conversation is assigned to {agentLink}</>;

  return <LogEntry entry={entry} text={text} />;
};
